var _templateObject = _taggedTemplateLiteralLoose(['\n\tbox-sizing: border-box;\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n\talign-items: flex-start;\n\t', '\n\t', '\n'], ['\n\tbox-sizing: border-box;\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n\talign-items: flex-start;\n\t', '\n\t', '\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import styled from 'styled-components';
import { mapTheme } from '../utils/breakpoints';
import Cell from './Cell';
var Row = styled.div(_templateObject, mapTheme(function (_ref, props) {
  var gutter = _ref.gutter;
  return gutter && !props['vertical-gutter'] && '\n\t\tmargin-left: ' + gutter / -2 + 'px;\n\t\tmargin-right: ' + gutter / -2 + 'px;\n\t\tmax-width: calc(100% + ' + gutter + 'px);\n\t';
}), mapTheme(function (_ref2, props) {
  var gutter = _ref2.gutter;
  return gutter && props['vertical-gutter'] && '\n\t\tmargin: ' + gutter / -2 + 'px;\n\t\t& ' + Cell + ' {padding: ' + gutter / 2 + 'px;}\n\t';
}));
export default Row;